<app-header [showAvatar]="false" title="Template #{{templateId}}" [useTabs]="false">
</app-header>
<div class="body">
  <div class="body-container">
    <div class="page-main" style="display: flex;">
      <div class="page-container size size1of3">
        <form *ngIf="isFormReady" class="form-wrapper">
          <div class="form-content">
            <!-- Subject -->
            <div class="form-section">
              <div class="form-section-side">
                <h1 class="label-title">Subject</h1>
              </div>
              <div class="form-section-container">
                <div class="form-section-head margin nomargin">
                  <p class="typo caption fw300 semi-condensed">What's the subject line for this campaign?</p>
                </div>
                <div class="form-section-body">
                  <section [@onLoadingStatusChange]='statusSpinnerFormSubject' class="loading form-row-loader">
                    <div class="loading-wrapper">
                      <mat-icon svgIcon="ico-loader" class="custom-mat-icon ico-size ico-sm"></mat-icon>
                      <label class="label-loading-message">Please wait</label>
                    </div>
                  </section>
                  <section [@onRowStatusChange]='statusFormSubjectEdit' class="panel inner-panel">
                    <form [formGroup]="formSubject" novalidate class="panel-wrapper">
                      <div class="panel-body">
                        <div class="form-block">
                          <div class="form-row">
                            <mat-form-field class="custom-mat-form-field size size1of1">
                              <mat-label>{{subjectLabel}}</mat-label>
                              <input matInput required formControlName="subject">
                            </mat-form-field>
                          </div>
                          <div class="form-row">
                            <mat-form-field class="custom-mat-form-field size size1of1">
                              <mat-label>{{previewTextLabel}}</mat-label>
                              <input matInput  formControlName="previewText">
                            </mat-form-field>
                          </div>
                        </div>
                      </div>
                    </form>
                    <div class="buttons-position">
                      <button mat-flat-button (click)="onSubmit('Subject', formSubject)"
                        [disabled]="formSubject.invalid" color="primary"
                        class="mat-button custom-mat-button">Save</button>
                      <a mat-button disableRipple="true" (click)="cancelForm('Subject', formSubject)"
                        class="custom-mat-button button-cancel">Cancel</a>
                    </div>
                  </section>
                  <section [@onRowStatusChange]='statusFormSubject' class="panel inner-panel">
                    <div class="panel-body">
                      <div class="form-block">
                        <div class="form-row row-no-editable">
                          <p class="typo body-1 fw400 semi-condensed">
                            {{template && template['subject'] ? template['subject'] : subjectLabel}}
                          </p>
                          <p class="typo body-1 fw400 semi-condensed">
                            {{template && template['previewText'] ? template['previewText'] : previewTextLabel}}
                          </p>
                        </div>

                      </div>
                    </div>
                    <div class="form-row row-no-editable">
                      <button mat-stroked-button
                        (click)="handleForm('Subject', formSubject)" color="primary" disableRipple="true"
                        class="custom-mat-button button-new-block">Edit
                        Subject</button>
                      <p class="typo caption fw300 semi-condensed">When it comes to email marketing, the best subject
                        lines tell what's inside instead of sell what's inside.</p>
                    </div>
                  </section>
                </div>
              </div>
            </div>

            <!-- Recipients -->

            <div class="form-section">
              <div class="form-section-side">
                <h1 class="label-title">Recipients</h1>
              </div>
              <div class="form-section-container">
                <div class="form-section-body">
                  <section [@onLoadingStatusChange]='statusSpinnerFormRecipients' class="loading form-row-loader">
                    <div class="loading-wrapper">
                      <mat-icon svgIcon="ico-loader" class="custom-mat-icon ico-size ico-sm"></mat-icon>
                      <label class="label-loading-message">Please wait</label>
                    </div>
                  </section>
                  <section [@onRowStatusChange]='statusFormRecipientsEdit' class="panel inner-panel">
                    <form [formGroup]="formRecipients" novalidate class="panel-wrapper">
                      <div class="panel-body">
                        <div class="form-block">
                          <div class="form-row">
                            <mat-form-field class="custom-mat-form-field size size1of1">
                              <mat-label>CC</mat-label>
                              <input matInput formControlName="cc">
                            </mat-form-field>
                          </div>
                          <div class="form-row">
                            <mat-form-field class="custom-mat-form-field size size1of1">
                              <mat-label>BCC</mat-label>
                              <input matInput  formControlName="bcc">
                            </mat-form-field>
                          </div>
                        </div>
                      </div>
                    </form>
                    <div class="buttons-position">
                      <button mat-flat-button (click)="onSubmit('Recipients', formRecipients)"
                              [disabled]="formRecipients.invalid" color="primary"
                              class="mat-button custom-mat-button">Save</button>
                      <a mat-button disableRipple="true" (click)="cancelForm('Recipients', formRecipients)"
                         class="custom-mat-button button-cancel">Cancel</a>
                    </div>
                  </section>
                  <section [@onRowStatusChange]='statusFormRecipients' class="panel inner-panel">
                    <div class="panel-body">
                      <div class="form-block">
                        <div class="form-row row-no-editable">
                          <p class="typo body-1 fw400 semi-condensed">
                            {{template && template['cc'] ? 'CC: ' + template['cc'] : ccLabel}}
                          </p>
                          <p class="typo body-1 fw400 semi-condensed">
                            {{template && template['bcc'] ? 'BCC: ' + template['bcc'] : bccLabel}}
                          </p>
                        </div>

                      </div>
                    </div>
                    <div class="form-row row-no-editable">
                      <button mat-stroked-button
                              (click)="handleForm('Recipients', formRecipients)" color="primary" disableRipple="true"
                              class="custom-mat-button button-new-block">Edit
                        recipients</button>
                      <p class="typo caption fw300 semi-condensed">Separate recipients with a comma</p>
                    </div>
                  </section>
                </div>
              </div>
            </div>
            <!-- Content -->
            <!-- <div class="form-section">
              <div class="form-section-side">
                <h1 class="label-title">Content</h1>
              </div>
              <div class="form-section-container">
                <div class="form-section-head margin nomargin">
                  <p class="typo caption fw300 semi-condensed">How your emails will look like?</p>
                </div>
                <div class="form-section-body">
                  <div class="content-img-container">
                    <img class="img" src="./assets/images/email-template.svg">
                    <p class="typo caption fw300 semi-condensed">Email Template</p>
                  </div>

                  <div class="form-row row-no-editable">
                    <button mat-stroked-button (click)="showEditorDialog()" color="primary" disableRipple="true"
                      class="custom-mat-button button-new-block">Edit Design</button>
                    <p class="typo caption fw300 semi-condensed">Describe what makes your product unique, useful, or
                      gift-worthy. Be sure to highlight the main features.</p>
                  </div>
                </div>
              </div>
            </div> -->
          </div>
        </form>

        <!-- skeleton form-sections -->
        <div *ngIf="!isFormReady">
          <skeleton-loader-form [top]=true [numberOfInputs]=2></skeleton-loader-form>
          <skeleton-loader-form [numberOfInputs]=2></skeleton-loader-form>
          <skeleton-loader-form [numberOfInputs]=2></skeleton-loader-form>
        </div>

      </div>
      <div *ngIf="isFormReady" class="page-container">
        <div class="form-wrapper" style="height: 900px; display: block;">
          <template-editor [_templateId]=templateId></template-editor>
        </div>
      </div>
    </div>
  </div>
</div>
